export const buildKioskApiUrl = (base: string, path: string): string => {
  if (/^https?:\/\//.test(path)) {
    return path;
  }

  const normalizedBase = base.replace(/\/+$/, "");
  const normalizedPath = path.replace(/^\/+/, "");

  if (!normalizedBase) {
    return `/${normalizedPath}`;
  }

  return `${normalizedBase}/${normalizedPath}`;
};
